import { twMerge } from "tailwind-merge";

type FormBuilderKeyValueTableRow = {
  id: string;
  label: string;
  value: string;
};

type FormBuilderKeyValueTableProps = {
  rows: FormBuilderKeyValueTableRow[];
};

const FormBuilderKeyValueTable = ({ rows }: FormBuilderKeyValueTableProps) => {
  const labeledRows = rows.filter((row) => row.label.trim().length > 0);

  if (labeledRows.length === 0) {
    return null;
  }

  return (
    <div className="flex w-fit max-w-full flex-col overflow-hidden rounded-md border border-gray-200">
      {labeledRows.map((row, index) => (
        <div
          key={row.id}
          className={twMerge(
            "flex items-start",
            index < labeledRows.length - 1 && "border-b border-gray-200",
          )}
        >
          <div className="flex w-80 shrink-0 px-4 py-2">
            <span className="text-base font-medium leading-6 text-gray-600">{row.label}</span>
          </div>
          <div className="flex min-w-[320px] flex-1 border-l border-gray-200 px-4 py-2">
            <span className="whitespace-pre-wrap text-base font-medium leading-6 text-gray-900">
              {row.value}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FormBuilderKeyValueTable;
